import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export interface FilterData {
  filter: string;
  AdvanceSearch: any;
  Type: string;
}

@Component({
    selector: 'app-vieworgcontact',
    templateUrl: './vieworgcontact.component.html',
    styleUrls: ['./vieworgcontact.component.css'],
    standalone: false
})
export class VieworgcontactComponent implements OnInit {
  master: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  DisplayMessage: string;
  FormSearchContactOrg: FormGroup;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  pageNumber: number;
  RightsID: string;
  pagetype: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  filteredData: any[] = [];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202034001') || this.RightsID.includes('202034021') || this.RightsID.includes('202034000')) {
      } else {
        window.location.href = "module/0";
      }
    this.pageNumber = 1;
    this.MsgType = 1; // Loading
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.pagetype = pagehead[2];
    this.FetchContactOrg(this.pagetype);
    this.FormSearchContactOrg = this.formBuilder.group({
      txtSearch: ['']
    });
    this.TypeHeader = pagehead[2].toString();
    if (pagehead[2].toString() == '1') {this.TypeHeader = 'Organization'; } else {
      this.TypeHeader = 'Contact';
    }
    this.FormSearchContactOrg.get('txtSearch').valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged()
    )
    .subscribe(value => {
      this.filterTable(value);
    });
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }

  receiveMessage(event) {
    if (event?.data?.data?.Param != null){
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch'));
    localStorage.setItem('advancesearch', "");
    this.FetchContactOrg(this.pagetype);
  }
  onSearchContactOrg(SearchData) {
    this.http.get(this.url + 'ContactOrg/FetchNavContactOrg?ContactType=' + this.pagetype + '&filter=' + SearchData.txtSearch)
    .subscribe( (data) => {
      if (data == null) {
        this.master = null; this.alertService.error('No Data Found', true);
      } else {
      this.master = JSON.parse(data.toString()); }
    }
  );
  }

  FetchContactOrg(type: string) {
    this.http.get(this.url + 'ContactOrg/FetchNavContactOrg?ContactType=' + type + '&filter=' + '')
    .subscribe( (data) => {
      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        this.master = null;
        this.filteredData = [];
      } else {
        this.MsgType = 0; // No Message
        this.master = JSON.parse(data.toString());
        this.totalRecords = this.master.length;
        this.filterTable('');
      }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
  goBack() {
    this.router.navigate(['/plan/plan/0']);
  }

  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.master];
      return;
    }

    this.filteredData = this.master.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
}
